export default __webpack_public_path__ + "static/media/aor2.b41d0cab.png";